import isFastTrackExpiringSoonLoyaltySelect from 'modules/loyalty/redux/selectors/is-fast-track-expiring-soon'
import getNextTierNameLoyaltySelect from 'modules/loyalty/redux/selectors/get-next-tier-name'
import isFastTrackExpiredLoyaltySelect from 'modules/loyalty/redux/selectors/is-fast-track-expired'
import { createSelector } from 'reselect'
import shouldShowFastTrackExpiryLoyaltySelectUtil from 'modules/loyalty/redux/selectors/should-show-fast-track-expiry/utils'

const shouldShowFastTrackExpiryLoyaltySelect = createSelector(
  isFastTrackExpiringSoonLoyaltySelect,
  isFastTrackExpiredLoyaltySelect,
  getNextTierNameLoyaltySelect,
  (
    isFastTrackExpiringSoon,
    isFastTrackExpired,
    nextTierName
  ) => {
    return shouldShowFastTrackExpiryLoyaltySelectUtil({
      isFastTrackExpiringSoon,
      isFastTrackExpired,
      nextTierName
    })
  }
)

export default shouldShowFastTrackExpiryLoyaltySelect
